<template>
<div>
    <h2>{{props.status.name}}</h2>

<!--
            'intent_title' => Reward::$intents[ $ob->intent ],
            'ctime' => $this->date2js($ob->ctime),
            'sum' => tbIFormat::intToFloat4($ob->bill_value),
-->

    <div class="ul">
        <div class="a">Статус</div>
        <div class="b">{{props.actreward.status_name}}</div>
    </div>
    <div class="ul">
        <div class="a">Тип выплаты</div>
        <div class="b">{{props.actreward.intent_title}}</div>
    </div>
    <div class="ul" v-if="'bank' == props.actreward.account.type">
        <div class="a">Ревизиты</div>
        <div class="b">Счет: {{props.actreward.account.anumber}}<br />БИК: {{props.actreward.account.bik}}</div>
    </div>
    <div class="ul">
        <div class="a">Создана</div>
        <div class="b">{{dayjsFormat(props.actreward.ctime)}}</div>
    </div>
    <div class="ul">
        <div class="a">Сумма</div>
        <div class="b">{{props.actreward.sum}}</div>
    </div>
    <div class="ul" v-if="props.actreward.comission">
        <div class="a">Комиссия</div>
        <div class="b">{{props.actreward.comission}}</div>
    </div>

    <h2>Подписанные документы</h2>


    <div v-for="ob in props.actreward.docs" :key="ob.key">
        <a :href="ob.url" target="_blank">{{ob.type_str}}</a>
    </div>

</div>
</template>

<style lang="scss">
.ul {
    display: grid;
    grid-template-columns: 30% 70%;
    max-width: 600px;
}
    
</style>

<script setup>
import dayjs from 'dayjs'    
// <RewardShow :claim="claimob.claim" :status="claimob.status" :actreward="claimob.actreward" />    
const props = defineProps({
  claim: Object,
  status: Object, 
  actreward: Object, 
})

const dayjsFormat = iso => dayjs(iso).format('DD.MM.YYYY HH:mm')

</script>
